import apiClient from "./apiClient";
import { DeleteRequest } from "@/types/deleteRequest";
import {ActReconciliation} from "../../src/types/act";
import {TemplateTypeEnum} from "@/enums/TemplateType";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

export async function createActReconciliation(token: string, params: any): Promise<ActReconciliation[]> {
    try {
        const response = await apiClient.post<ActReconciliation[]>(
            `${BASE_URL}/api/v1/act/create`,
            params,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        )
        return response.data;
    } catch (error) {
        console.error("Error fetching directory list:", error);
        throw error;
    }
}

export async function getAllActReconciliations(token: string, params: any): Promise<any> {
    try {
        params.filter = removeNullFields(params.filter);

        const response = await apiClient.post<any>(
            `${BASE_URL}/api/v1/act/all`,
            params,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        )
        return response.data;
    } catch (error) {
        console.error("Error fetching directory list:", error);
        throw error;
    }
}

export async function refreshActReconciliation(token: string, data: ActReconciliation): Promise<ActReconciliation> {
    try {
        const response = await apiClient.post<ActReconciliation>(
            `${BASE_URL}/api/v1/act/refresh`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        )
        return response.data;
    } catch (error) {
        console.error("Error fetching directory list:", error);
        throw error;
    }
}

export async function refreshAllActReconciliation(page: any, type: any): Promise<any> {
    try {
        const response = await apiClient.post<any>(
            `${BASE_URL}/api/v1/act/refresh-all/${type}`,
            page
        )
        return response;
    } catch (error) {
        console.error("Error", error);
        throw error;
    }
}

export async function acceptActReconciliation(token: string, data: ActReconciliation): Promise<ActReconciliation> {
    try {
        const response = await apiClient.post<ActReconciliation>(
            `${BASE_URL}/api/v1/act/accept`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        )
        return response.data;
    } catch (error) {
        console.error("Error fetching directory list:", error);
        throw error;
    }
}

export async function generateReport(token: string, templateType: TemplateTypeEnum, params: any): Promise<any> {
    try {
        params.filter = removeNullFields(params.filter);

        return await apiClient.post<any>(
            `${BASE_URL}/api/v1/act/report/generate/${templateType}`,
            params,
            {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        )
    } catch (error) {
        console.error("Error fetching directory list:", error);
        throw error;
    }
}

export async function restoreActByKindergartenCalculationIdList(idList: string[], reason: string) {
    const response = await apiClient.post(
      `${BASE_URL}/api/v1/act/restore`,
        { ids: idList, reason } as DeleteRequest<string>
    );
    return response.status;
}

/** confirmReconciled — пользователь подтвердил удаление актов с успешно сверенным счётом-фактурой. */
export async function deleteActByKindergartenCalculationIdList(idList: string[], reason: string, confirmReconciled = false) {
    try {
        const response = await apiClient.post(
          `${BASE_URL}/api/v1/act/delete`,
            { ids: idList, reason } as DeleteRequest<string>,
            { params: { confirmReconciled } }
        );
        return response.status;
    } catch (error) {
        console.error("Error deleting by kindergarten calculation id list:", error);
        throw error;
    }
}